import { jsx as c, jsxs as S } from "react/jsx-runtime";
import { QUERIES as _ } from "@fcamna/shared-component-foundations";
import { c as B } from "./index-65016bfa.mjs";
import { useState as w, useMemo as P, useCallback as U, createContext as q, forwardRef as D, useContext as x, useRef as H, createElement as L } from "react";
import d, { css as m, styled as A } from "styled-components";
import "./isClient-ec947a14.mjs";
import { u as v } from "./useMediaQuery-2533ee8a.mjs";
import { b as M, e as J } from "./useSlots-a1aa6a84.mjs";
import { ButtonGroup as K } from "./buttonGroup.js";
import { ButtonV1 as X } from "./buttonV1.js";
import { CloseButton as $ } from "./closeButton.js";
import { D as I } from "./index-2be68378.mjs";
import { Icon as G } from "./icon.js";
import { IconButton as k } from "./iconButton.js";
import { c as O } from "./cloneSlots-333ddef1.mjs";
import { c as Y } from "./combineRefs-90f27925.mjs";
const Z = d.div`
  &.ActionBar {
    ${({
  theme: {
    components: { actionBar: t }
  }
}) => m(t.ActionBarContainer)}
  }
  ,

`, F = d(k)`
  &&.ActionBar__StyledIconButton {
    ${({
  theme: {
    components: { actionBar: t }
  }
}) => m(t.StyledIconButton)}
  }
`, T = d.div`
  &.ActionBar__selection-summary {
    ${({
  theme: {
    components: { actionBar: t }
  }
}) => m(t.SelectionSummary)}
  }
`, tt = d.div`
  &.ActionBar__selection-summary-TitleWrapper {
    ${({
  theme: {
    components: { actionBar: t }
  }
}) => m(t.SelectTitleWrapper)}
  }
`, et = d(K)`
  &.ButtonGroup {
    ${({
  theme: {
    components: { actionBar: t }
  }
}) => m(t.ButtonGroup)}
  }
`, W = ({ count: t = 0, title: e = "Selected", children: l }) => {
  var n;
  const u = M(l, { button: $ });
  return /* @__PURE__ */ S(T, { className: "ActionBar__selection-summary", children: [
    u.button.length > 0 && /* @__PURE__ */ c(
      $,
      {
        name: "cancelClose",
        ...(n = u.button[0]) == null ? void 0 : n.props,
        size: "medium",
        surface: "dark",
        color: "default"
      }
    ),
    /* @__PURE__ */ S(tt, { className: "ActionBar__selection-summary-TitleWrapper ", children: [
      /* @__PURE__ */ c("span", { children: t }),
      " ",
      /* @__PURE__ */ c("span", { children: e })
    ] })
  ] });
}, j = (t) => /* @__PURE__ */ c(X, { ...t }), Q = ({ variant: t = "default", dropDownTriggerProps: e, children: l, ...u }) => {
  const n = v(_.mobile), [a, b] = w(!1), C = M(l, { selectionSection: W, items: j }), r = P(
    () => C.items.map((i) => ({
      variant: "tertiary",
      ...i == null ? void 0 : i.props,
      color: "onColor"
    })).slice(0, t === "saveClose" ? 2 : 4),
    [C.items, t]
  ), f = U(() => /* @__PURE__ */ c(
    et,
    {
      className: `ButtonGroup--${t}`,
      size: "medium",
      buttonData: r
    }
  ), [r, t]), y = () => {
    const i = t === "dropDown" ? r : [...r].reverse();
    return /* @__PURE__ */ S(
      I,
      {
        menuOpen: a,
        menuDirection: "down_right",
        closeOnSelect: !0,
        onChange: (o, s) => {
          var N, z;
          const h = +s.value.replace(s.label, "");
          (z = (N = i[h]) == null ? void 0 : N.onClick) == null || z.call(N, o);
        },
        handleMenuOpen: () => {
          b((o) => !o);
        },
        children: [
          /* @__PURE__ */ c(I.Control, { children: t === "dropDown" && !n ? /* @__PURE__ */ c(
            X,
            {
              type: "onColor",
              color: "onColor",
              variant: "primary",
              ...e,
              children: (e == null ? void 0 : e.label) || "Button"
            }
          ) : /* @__PURE__ */ c(
            F,
            {
              className: "ActionBar__StyledIconButton",
              size: "medium",
              iconName: "moreVertical",
              color: "oncolor",
              variant: a ? "primary" : "tertiary"
            }
          ) }),
          i.map((o, s) => /* @__PURE__ */ c(
            I.Item,
            {
              label: o.label,
              value: `${o.label} ${s}`,
              id: `${o.label} ${s}`,
              leadingElement: o != null && o.leftIcon && typeof o.leftIcon == "string" ? /* @__PURE__ */ c(G, { name: o.leftIcon }) : o.leftIcon,
              trailingElement: o != null && o.rightIcon && typeof o.rightIcon == "string" ? /* @__PURE__ */ c(G, { name: o.rightIcon }) : o.rightIcon
            },
            `${o.label} ${s}`
          ))
        ]
      }
    );
  };
  return /* @__PURE__ */ S(
    Z,
    {
      className: B(["ActionBar", `ActionBar--${t}`]),
      ...u,
      children: [
        t !== "saveClose" && C.selectionSection,
        t === "default" && !n && f(),
        t === "saveClose" ? f() : (t === "dropDown" || n) && y()
      ]
    }
  );
};
W.CloseButton = $;
Q.Item = j;
Q.SelectionSection = W;
const p = q(null), ot = d.div`
  &.Carousel__content {
    ${({
  theme: {
    components: { carousel: t }
  }
}) => m(t.CarouselContent)};
  }
`, V = D((t, e) => {
  const l = x(p);
  return /* @__PURE__ */ c(
    ot,
    {
      ...t,
      ref: Y(e, l),
      className: B(["Carousel__content", t.className])
    }
  );
}), E = (t) => {
  const e = x(p), l = v(_.mobile), u = (n) => {
    var a;
    (a = t.onClick) == null || a.call(t, n), e != null && e.current && (e.current.scrollLeft -= l ? e.current.clientWidth : e.current.clientWidth / 2);
  };
  return /* @__PURE__ */ c(
    k,
    {
      ...t,
      color: "oncolor",
      iconName: "caretLeft",
      size: "extra-small",
      className: B(["CarouselPrevButton", t.className]),
      onClick: u
    }
  );
}, R = (t) => {
  const e = x(p), l = v(_.mobile), u = (n) => {
    var a;
    (a = t.onClick) == null || a.call(t, n), e != null && e.current && (e.current.scrollLeft += l ? e.current.clientWidth : e.current.clientWidth / 2);
  };
  return /* @__PURE__ */ c(
    k,
    {
      ...t,
      color: "oncolor",
      iconName: "caretRight",
      size: "extra-small",
      className: B(["CarouselNextButton", t.className]),
      onClick: u
    }
  );
}, nt = A.div`
  &.Carousel {
    ${({
  theme: {
    components: { carousel: t }
  }
}) => m(t.Carousel)};
  }
`, ct = A(E)`
  &.PreviousButton {
    ${({
  theme: {
    components: { carousel: t }
  }
}) => m(t.PreviousButton)};
  }
`, lt = A(R)`
  &.NextButton {
    ${({
  theme: {
    components: { carousel: t }
  }
}) => m(t.NextButton)};
  }
`, g = D(({ hideOverFlowGradient: t, hideControls: e = !1, ...l }, u) => {
  const n = H(null), { isScrollableX: a, isScrollXAtEnd: b, isScrollXAtStart: C } = J(n == null ? void 0 : n.current), r = M(l.children, {
    contents: V,
    prevButton: E,
    nextButton: R
  }), f = O(r.prevButton, (s, h) => /* @__PURE__ */ L(
    ct,
    {
      ...s,
      key: h,
      className: B(["PreviousButton", s.className])
    }
  )), y = O(r.nextButton, (s, h) => /* @__PURE__ */ L(
    lt,
    {
      ...s,
      key: h,
      className: B(["NextButton", s.className])
    }
  )), i = a && !C, o = a && !b;
  return /* @__PURE__ */ c(p.Provider, { value: n, children: /* @__PURE__ */ S(
    nt,
    {
      ref: u,
      ...l,
      className: B([
        "Carousel",
        {
          "Carousel--left": !t && i,
          "Carousel--right": !t && o
        },
        l.className
      ]),
      children: [
        (!e || !!f) && i && f,
        r == null ? void 0 : r.contents,
        " ",
        r == null ? void 0 : r.rest,
        (!e || !!y) && o && y
      ]
    }
  ) });
});
g.PrevButton = E;
g.NextButton = R;
g.Content = V;
export {
  Q as A,
  g as C
};
